import { render, staticRenderFns } from "./AcademicFormationForm.vue?vue&type=template&id=2cf6772a&scoped=true&"
import script from "./AcademicFormationForm.vue?vue&type=script&lang=ts&"
export * from "./AcademicFormationForm.vue?vue&type=script&lang=ts&"
import style0 from "./AcademicFormationForm.vue?vue&type=style&index=0&id=2cf6772a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6772a",
  null
  
)

export default component.exports